import { render } from "./ChallengeHeaderV2.vue?vue&type=template&id=58e6559d&scoped=true"
import script from "./ChallengeHeaderV2.vue?vue&type=script&lang=js"
export * from "./ChallengeHeaderV2.vue?vue&type=script&lang=js"

import "./ChallengeHeaderV2.vue?vue&type=style&index=0&id=58e6559d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e6559d"]])

export default __exports__